export const requireStateInputCountries = ['US', 'CA'];
